import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2727feb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "event-form" }
const _hoisted_2 = { action: "" }
const _hoisted_3 = { class: "error-message" }

import { ref } from 'vue';
  import FormButtons from '../FormButtons.vue';
  import * as eventFormData from '@/assets/data/eventFormData.json';
  import InputField from '@/components/InputField.vue';
  import { EventData, FormItem } from '@/models/FormModels';
  import { useVuelidate } from '@vuelidate/core';
  import { required, helpers } from '@vuelidate/validators';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EventForm',
  emits: ["onNextClick"],
  setup(__props, { emit }: { emit: ({
    (e: 'onNextClick', formData: EventData): void;
  }), expose: any, slots: any, attrs: any }) {

  

  const occassions = ref<{name: string}[]>(eventFormData.occassions);
  const numbersGuests = ref<{displayName: string, value: number}[]>(eventFormData.numbersGuests);
  const durations = ref<{displayName: string, value: number}[]>(eventFormData.durations);
  const genres = ref<{displayName: string, value: string}[]>(eventFormData.musicGenres);
  const eventData = ref<EventData>(new EventData());

  const formItems: FormItem[] = [
    new FormItem('occassion', 'Anlass*', occassions.value, 'dropdown', 'Anlass auswählen', 'name'),
    new FormItem('date', 'Datum*', undefined, 'date'),
    new FormItem('numberGuests', 'Anzahl Gäste*', numbersGuests.value, 'dropdown', 'Anzahl Gäste auswählen', 'displayName'),
    new FormItem('duration','Musikdauer*', durations.value, 'dropdown', 'Musikdauer', 'displayName'),
    new FormItem('music', 'Musikgenre', genres.value, 'chips', undefined, 'displayName')
  ];

  const minDateVal = (newDate: string) => newDate > new Date().toISOString();

  const validationRules = {
    occassion: { required: helpers.withMessage('Anlass auswählen', required) },
    date: { required: helpers.withMessage('Datum auswählen', required), minDateVal: helpers.withMessage('Datum liegt in Vergangenheit', minDateVal) },
    numberGuests: { required: helpers.withMessage('Anzahl Gäste auswählen', required) },
    duration: { required: helpers.withMessage('Dauer auswählen', required) },
    music: {}
  }

  const v$ = useVuelidate(validationRules, eventData);
 
  const validated = ref(false);
  const nextPage = async() => {
    validated.value = true;
    const isFormValid = await v$.value.$validate();
    if (isFormValid) {
      emit('onNextClick', eventData.value);
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(formItems, (item, index) => {
        return _createElementVNode("div", { key: index }, [
          _createVNode(InputField, {
            class: _normalizeClass((_unref(v$)[item.selectedKey].$invalid || _unref(v$)[item.selectedKey].$pending) && validated.value ? 'invalid' : ''),
            type: item.type,
            label: item.label,
            selected: _unref(v$)[item.selectedKey].$model,
            "onUpdate:selected": ($event: any) => ((_unref(v$)[item.selectedKey].$model) = $event),
            options: item.options,
            optionLabel: item.optionLabel,
            placeholder: item.placeholder,
            id: item.selectedKey
          }, {
            errorMessage: _withCtx(() => [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(v$)[item.selectedKey]?.$silentErrors?.length > 0 ? _unref(v$)[item.selectedKey].$silentErrors[0].$message : 'no'), 1)
            ]),
            _: 2
          }, 1032, ["class", "type", "label", "selected", "onUpdate:selected", "options", "optionLabel", "placeholder", "id"])
        ])
      }), 64))
    ]),
    _createVNode(FormButtons, {
      class: "buttons",
      next: true,
      onClickRight: nextPage
    })
  ]))
}
}

})